export default __webpack_public_path__ + "static/media/DisneyMarvelAvengers1.679a94d0.jpg";